import DisplayTrack2 from "./DisplayTracks/DisplayTracks2";
import './_audioplayer2.scss';
import {useState, useRef} from "react";
import {motion} from 'framer-motion';

const AudioPlayer2 = (props) => {
    const tracks = props.tracks
    const trackIndex= props.trackIndex
    const setTrackIndex= props.setTrackIndex
    const currentTrack= props.currentTrack
    const isPlaying= props.isPlaying
    const setIsPlaying= props.setIsPlaying
    const [tracklistOpen, setTracklistOpen] = useState(false)

    // reference
    const audioRef = useRef();

    const changeTrack = (index) => {
    setTrackIndex(index);
    setIsPlaying(true);
    }

    return (
            <motion.div className="audio-player2"
            >
                <div className="inner2" key="1">
                    <DisplayTrack2
                        currentTrack={currentTrack}
                        audioRef={audioRef}
                        tracks={tracks}
                        trackIndex={trackIndex}
                        setTrackIndex={setTrackIndex}
                        isPlaying={isPlaying}
                        setIsPlaying={setIsPlaying}
                        tracklistOpen={tracklistOpen}
                        setTracklistOpen={setTracklistOpen}
                    />
                </div>
                {tracklistOpen?
                <motion.div className="track-list" key="2"
                            initial={{opacity : 0}}
                            animate={{opacity : 1, transition: {duration: 0.8} }}
                            exit={{opacity: 0, transition: {duration: 0.8} }}
                >
                    <div className="tracklist-header">
                    <span><h3>Tracklist</h3>
                    <p>{trackIndex +1 } / {tracks.length}</p>
                        </span>
                    </div>
                    <div className="tracklist-container">
                    {tracks.map((obj, index) => (
                        <div
                            className={`tracklist-item ${currentTrack.id === obj.id ? "active" : ""}`}
                            key={index}
                            onClick={() => changeTrack(index)}
                        >
                            <p>{obj.title}</p>
                            <p>{obj.duration}</p>
                        </div>
                    ))}
                    </div>
                </motion.div> : <></>}
            </motion.div>
    );
};
export default AudioPlayer2;